<template>
  <dynamic-image-background :file-id="fileId" :class="imageClass" :id="imageId" :background-style="imageStyle" ></dynamic-image-background>
  <!-- <img :src="imageSource" v-if="imageSource" :id="imageId" :class="imageClass"> -->
</template>

<script>
import DynamicImageBackground from "./DynamicImageBackground.vue";
export default {
  components: { DynamicImageBackground },
  name: "ProfileImage",

  props: ["fileId", "imageId", "imageClass", "imageStyle"],
};
</script>
